import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "../materail/materail.module";

/* Components*/
import { DaterangepickerComponent } from "./daterangepicker/daterangepicker.component";
import { DropdownComponent } from "./dropdown/dropdown.component";
import { SearchableDropdownComponent } from "./searchable-dropdown/searchable-dropdown.component";
import { StockchartComponent } from "./charts/stockchart/stockchart.component";

/* High Charts */
import { ChartModule, HIGHCHARTS_MODULES } from "angular-highcharts";
import { HighchartsChartModule } from "highcharts-angular";
import stock from "highcharts/modules/stock.src";
import more from "highcharts/highcharts-more.src";

import {
  LocaleService,
  NgxDaterangepickerMd,
} from "ngx-daterangepicker-material";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { PieChartComponent } from "./charts/pie-chart/pie-chart.component";
import { NgxPaginationModule } from "ngx-pagination";
import { SemiGuageComponent } from "./charts/semi-guage/semi-guage.component";
import { LineChartComponent } from "./charts/line-chart/line-chart.component";
import { BarChartComponent } from "./charts/bar-chart/bar-chart.component";
import { AreaChartComponent } from "./charts/area-chart/area-chart.component";
import { StackedbarChartComponent } from "./charts/stackedbar-chart/stackedbar-chart.component";
import { ColumnChartComponent } from "./charts/column-chart/column-chart.component";
import { BasicbarChartComponent } from "./charts/basicbar-chart/basicbar-chart.component";
import { ArearangeChartComponent } from "./charts/arearange-chart/arearange-chart.component";
import { AreaRangeChartComponent } from "./charts/area-range-chart/area-range-chart.component";
import { CalenderComponent } from "./calender/calender.component";
// import { FlatpickrModule } from 'angularx-flatpickr';
import { DonutChartComponent } from "./charts/donut-chart/donut-chart.component";
import { LoaderComponent } from "./loader/loader.component";
import { BasiccolumnChartComponent } from "./charts/basiccolumn-chart/basiccolumn-chart.component";
import { MaterialDatepickerComponent } from "./material-datepicker/material-datepicker.component";
import { ProgressbarcolorDirective } from "./directives/progressbarcolor.directive";
import { OrderModule } from "ngx-order-pipe";
import { PyramidComponent } from "./charts/pyramid/pyramid.component";
import { VarDirectiveDirective } from "./directives/var-directive.directive";
import { ExpansionComponent } from "./expansion/expansion.component";
import { FormfieldValidatorComponent } from "./formfield-validator/formfield-validator.component";
import { ModalPopupsComponent } from "./modal-popups/modal-popups.component";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import { MessageComponent } from './message/message.component';
import { MatTreeSidebarComponent } from './mat-tree-sidebar/mat-tree-sidebar.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SingleCardComponent } from './single-card/single-card.component';
import { PaginationComponent } from './pagination/pagination.component';
import { BasicdonutChartComponent } from './charts/basicdonut-chart/basicdonut-chart.component';
import { PrimeTableComponent } from './prime-table/prime-table.component';
import { TagModule } from 'primeng/tag';
import { HttpClientModule } from '@angular/common/http';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
    import { AvatarModule } from 'primeng/avatar';
    import { AvatarGroupModule } from 'primeng/avatargroup';
    import { AccordionModule } from 'primeng/accordion';
    import { AutoCompleteModule } from 'primeng/autocomplete';
    import { BadgeModule } from 'primeng/badge';
    import { BreadcrumbModule } from 'primeng/breadcrumb';
    import { BlockUIModule } from 'primeng/blockui';
    import { ButtonModule } from 'primeng/button';
    import { CarouselModule } from 'primeng/carousel';
    import { CascadeSelectModule } from 'primeng/cascadeselect';
    import { CheckboxModule } from 'primeng/checkbox';
    import { ChipModule } from 'primeng/chip';
    import { ColorPickerModule } from 'primeng/colorpicker';
    import { ConfirmDialogModule } from 'primeng/confirmdialog';
    import { ConfirmPopupModule } from 'primeng/confirmpopup';
    import { ContextMenuModule } from 'primeng/contextmenu';
    import { DataViewModule } from 'primeng/dataview';
    import { DialogModule } from 'primeng/dialog';
    import { DividerModule } from 'primeng/divider';
    import { DeferModule } from 'primeng/defer';
    import { DockModule } from 'primeng/dock';
    import { DragDropModule } from 'primeng/dragdrop';
    import { DynamicDialogModule } from 'primeng/dynamicdialog';
    import { EditorModule } from 'primeng/editor';
    import { FieldsetModule } from 'primeng/fieldset';
    import { FileUploadModule } from 'primeng/fileupload';
    import { FocusTrapModule } from 'primeng/focustrap';
    import { GalleriaModule } from 'primeng/galleria';
    import { InplaceModule } from 'primeng/inplace';
    import { InputMaskModule } from 'primeng/inputmask';
    import { InputSwitchModule } from 'primeng/inputswitch';
    import { ImageModule } from 'primeng/image';
    import { KnobModule } from 'primeng/knob';
    import { ListboxModule } from 'primeng/listbox';
    import { MegaMenuModule } from 'primeng/megamenu';
    import { MenuModule } from 'primeng/menu';
    import { MenubarModule } from 'primeng/menubar';
    import { MessageModule } from 'primeng/message';
    import { MessagesModule } from 'primeng/messages';
    import { OrganizationChartModule } from 'primeng/organizationchart';
    import { OrderListModule } from 'primeng/orderlist';
    import { OverlayPanelModule } from 'primeng/overlaypanel';
    import { PaginatorModule } from 'primeng/paginator';
    import { PanelModule } from 'primeng/panel';
    import { PanelMenuModule } from 'primeng/panelmenu';
    import { PasswordModule } from 'primeng/password';
    import { PickListModule } from 'primeng/picklist';
    import { ProgressSpinnerModule } from 'primeng/progressspinner';
    import { ProgressBarModule } from 'primeng/progressbar';
    import { RadioButtonModule } from 'primeng/radiobutton';
    import { RatingModule } from 'primeng/rating';
    import { SelectButtonModule } from 'primeng/selectbutton';
    import { SidebarModule } from 'primeng/sidebar';
    import { ScrollPanelModule } from 'primeng/scrollpanel';
    import { ScrollTopModule } from 'primeng/scrolltop';
    import { SkeletonModule } from 'primeng/skeleton';
    import { SliderModule } from 'primeng/slider';
    import { SpeedDialModule } from 'primeng/speeddial';
    import { SplitterModule } from 'primeng/splitter';
    import { SplitButtonModule } from 'primeng/splitbutton';
    import { StepsModule } from 'primeng/steps';
    import { TabMenuModule } from 'primeng/tabmenu';
    import { TerminalModule } from 'primeng/terminal';
    import { TieredMenuModule } from 'primeng/tieredmenu';
    import { TimelineModule } from 'primeng/timeline';
    import { ToastModule } from 'primeng/toast';
    import { ToggleButtonModule } from 'primeng/togglebutton';
    import { ToolbarModule } from 'primeng/toolbar';
    import { TooltipModule } from 'primeng/tooltip';
    import { TreeModule } from 'primeng/tree';
    import { TreeSelectModule } from 'primeng/treeselect';
    import { TreeTableModule } from 'primeng/treetable';
import { CellRendererComponent } from './cell-renderer/cell-renderer.component';

export function highchartsModules() {
  return [stock, more];
}

export const MY_FORMATS = {
  parse: {
    dateInput: "LL",
  },
  display: {
    dateInput: "YYYY-MM-DD",
    monthYearLabel: "YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "YYYY",
  },
};

@NgModule({
  declarations: [
    DaterangepickerComponent,
    DropdownComponent,
    SearchableDropdownComponent,
    StockchartComponent,
    PieChartComponent,
    SemiGuageComponent,
    LineChartComponent,
    BarChartComponent,
    AreaChartComponent,
    StackedbarChartComponent,
    ColumnChartComponent,
    BasicbarChartComponent,
    ArearangeChartComponent,
    AreaRangeChartComponent,
    CalenderComponent,
    DonutChartComponent,
    LoaderComponent,
    BasiccolumnChartComponent,
    MaterialDatepickerComponent,
    ProgressbarcolorDirective,
    PyramidComponent,
    VarDirectiveDirective,
    ExpansionComponent,
    FormfieldValidatorComponent,
    ModalPopupsComponent,
    MessageComponent,
    MatTreeSidebarComponent,
    SingleCardComponent,
    PaginationComponent,
    BasicdonutChartComponent,
    PrimeTableComponent,
    // CellRendererComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ChartModule,
    HighchartsChartModule,
    NgxPaginationModule,
    NgxDaterangepickerMd.forRoot(),
    OrderModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    Ng2SearchPipeModule,
    NgbModule,
  ],
  exports: [
    /** Components**/
    DropdownComponent,
    SearchableDropdownComponent,
    StockchartComponent,
    DaterangepickerComponent,
    ReactiveFormsModule,
    PieChartComponent,
    NgxPaginationModule,
    SemiGuageComponent,
    LineChartComponent,
    BarChartComponent,
    AreaChartComponent,
    StackedbarChartComponent,
    ColumnChartComponent,
    BasicbarChartComponent,
    ArearangeChartComponent,
    AreaRangeChartComponent,
    PaginationComponent,
    // CalenderComponent
    DonutChartComponent,
    LoaderComponent,
    BasiccolumnChartComponent,
    MaterialDatepickerComponent,
    ProgressbarcolorDirective,
    OrderModule,
    PyramidComponent,
    VarDirectiveDirective,
    FormfieldValidatorComponent,
    ExpansionComponent,
    ModalPopupsComponent,
    Ng2SearchPipeModule,
    MessageComponent,
    MatTreeSidebarComponent,
    SingleCardComponent,
    BasicdonutChartComponent
  ],

  providers: [
    { provide: HIGHCHARTS_MODULES, useFactory: highchartsModules },
    LocaleService, // add as factory to your providers
  ],
})
export class CommonCoponentsModule {}
